import React from 'react';
import {Link, useHistory} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import {
  MAIN_SIDEBAR_DATA_REPORTER,
  MAIN_SIDEBAR_EXECUTIVE,
  MAIN_SIDEBAR_OWNER,
  MAIN_SIDEBAR_VALIDATOR,
} from '@app/store/menu-routes';
import {WhiteButton} from '@styled';
import AddEntityController from '@modules/entity/AddEntityController';
import {
  ROLE_OWNER,
  ROLE_EXECUTIVE_REPORTER,
  ROLE_VALIDATOR,
  ROLE_DATA_REPORTER,
} from '@app/utils/constants';

import MenuItem from './MenuItem';
import {sagaActions} from '../redux/saga';

const StyledCategoryWrapper = styled.div`
  display: ${({role}) =>
    [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER].includes(role)
      ? 'block'
      : 'none'};
`;

const StyledSidebar = styled.div`
  height: ${({role}) =>
    [ROLE_EXECUTIVE_REPORTER, ROLE_DATA_REPORTER].includes(role)
      ? 'calc(100% - (4rem + 150px)) !important'
      : 'calc(100% - (3.5rem + 1px))'};
`;

const MainMenuSidebar = ({toggleMenuSidebar}) => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const {corporateStructure, isFetchedCorpStruct} = useSelector((state) => ({
    corporateStructure: state.layout.corporateStructure,
    isFetchedCorpStruct: state.layout.isFetchedCorpStruct,
  }));

  const dispatch = useDispatch();
  const history = useHistory();

  const {MENU_ITEMS, USER_ROLE} = React.useMemo(() => {
    const CURRENT_ROLES = currentUser.Roles || [];
    if (CURRENT_ROLES.includes(ROLE_OWNER)) {
      return {MENU_ITEMS: MAIN_SIDEBAR_OWNER, USER_ROLE: ROLE_OWNER};
    }
    if (CURRENT_ROLES.includes(ROLE_EXECUTIVE_REPORTER)) {
      if (!isFetchedCorpStruct) {
        dispatch({type: sagaActions.FETCH_CORPORATE_STRUCTURE, payload: {}});
      }
      return {
        MENU_ITEMS: [...MAIN_SIDEBAR_EXECUTIVE, ...corporateStructure],
        USER_ROLE: ROLE_EXECUTIVE_REPORTER,
      };
    }

    if (CURRENT_ROLES.includes(ROLE_VALIDATOR)) {
      return {
        MENU_ITEMS: MAIN_SIDEBAR_VALIDATOR,
        USER_ROLE: ROLE_VALIDATOR,
      };
    }

    if (CURRENT_ROLES.includes(ROLE_DATA_REPORTER)) {
      if (!isFetchedCorpStruct) {
        dispatch({type: sagaActions.FETCH_CORPORATE_STRUCTURE, payload: {}});
      }
      return {
        MENU_ITEMS: [...MAIN_SIDEBAR_DATA_REPORTER, ...corporateStructure],
        USER_ROLE: ROLE_DATA_REPORTER,
      };
    }

    return {MENU_ITEMS: [], USER_ROLE: ''};
  }, [currentUser, corporateStructure, isFetchedCorpStruct]);

  const handleAddActivity = () => {
    history.push('/activities/add');
  };

  return (
    <aside className="main-sidebar sidebar-light-primary sidebar-no-expand  elevation-1 cce-main-sidebar cce-main-sidebar-width">
      <div
        className="cce-logo cce-brand-width d-none d-lg-flex"
        style={{justifyContent: 'flex-start'}}
      >
        <Link
          to="/"
          className="cce-logo-link"
          style={{padding: '11px 0 0 23px'}}
        >
          <span className="cce-logo-title" style={{fontWeight: 900}}>
            <span style={{fontSize: '24px', display: 'block'}}>CCE</span>
            <span style={{fontSize: '18px'}}>Data Portal</span>
          </span>
        </Link>
      </div>
      <StyledCategoryWrapper role={USER_ROLE} className="mt-2">
        <WhiteButton className="btn-block rounded-0 elevation-1 border-left-0 border-right-0">
          Corporate Structure
        </WhiteButton>
      </StyledCategoryWrapper>
      <StyledSidebar className="sidebar cce-sidebar" role={USER_ROLE}>
        <nav className="mt-2" style={{overflow: 'hidden'}}>
          <ul
            className="nav nav-pills nav-sidebar flex-column cce-nav-bar cce-main-sidebar-nav-icons"
            role="menu"
          >
            {MENU_ITEMS.map((menuItem) => (
              <MenuItem key={menuItem.name} menuItem={menuItem} />
            ))}
          </ul>
        </nav>
      </StyledSidebar>
      <StyledCategoryWrapper role={USER_ROLE}>
        {currentUser.Roles.includes(ROLE_EXECUTIVE_REPORTER) ? (
          <AddEntityController toggleMenuSidebar={toggleMenuSidebar} />
        ) : (
          <div style={{height: '20px'}} />
        )}
        <WhiteButton
          className="btn-block mb-1 rounded-0 border-left-0 border-right-0"
          onClick={handleAddActivity}
        >
          Add Activity
        </WhiteButton>
      </StyledCategoryWrapper>
    </aside>
  );
};

export default MainMenuSidebar;
